import { render, staticRenderFns } from "./DaysOfWeek.vue?vue&type=template&id=6dac7c99&scoped=true"
import script from "./DaysOfWeek.vue?vue&type=script&lang=ts"
export * from "./DaysOfWeek.vue?vue&type=script&lang=ts"
import style0 from "./DaysOfWeek.vue?vue&type=style&index=0&id=6dac7c99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dac7c99",
  null
  
)

export default component.exports